import { useMemo } from "react";
import { OHLCData } from "../types/ohlc";
import { GlobalStore } from "../store/global/GlobalStore";
import { Address } from "viem";

interface UseTransformedChartDataReturnType {
  transformedChartData: Array<Array<number>>;
  isError: boolean;
}

export const useTransformedChartData = (
  tokenAddress: Address
): UseTransformedChartDataReturnType => {
  const chartData = GlobalStore.useState(s => s.chartLists?.[tokenAddress]);

  const { transformedChartData, isError } = useMemo(() => {
    if (!chartData || chartData.length === 0) {
      return { transformedChartData: [], isError: true, isLoading: false };
    }

    const transformedData = chartData.map((data: OHLCData) => [
      data.t,
      data.o,
      data.c,
      data.l,
      data.h,
    ]);

    return { transformedChartData: transformedData, isError: false };
  }, [chartData]);

  return { transformedChartData, isError };
};
